import { useAppContext } from "../../contexts/AppContext";
import { Topbar } from '../../components/layout/Topbar';
import logo from '../../assets/sengi.png';
import { useNavigate } from "react-router-dom";
import { oauthClient } from '../../apis/OAuthClient';

interface CustomTopbarProps {
    onSidebarToggle: () => void;
    sidebarCollapsed: boolean;
}

export const CustomTopbar = ({
    sidebarCollapsed,
    onSidebarToggle
}:CustomTopbarProps) => {
    const context = useAppContext();
    const navigate = useNavigate();

    const logout = () => {
    context.setShowSidebar(false);
    context.setShowTopbar(false);
      // open oauth authorization
      oauthClient.logout();
      navigate('/login');
    };
    

    return (
        <>
        {context?.showTopbar ?
            <Topbar 
                icon={logo}
                onSidebarToggle={onSidebarToggle}
                sidebarCollapsed={sidebarCollapsed}
                logoutHandler={logout}
            />
            :
            <></> 

        }
        </>
    );
}
